"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Container = _interopRequireDefault(require("@mui/material/Container"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["children"];
var _templateObject;
var GridContainerStyles = (0, _styledComponents.default)(_Container.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n"])), function (props) {
  return props.containerBackgroundColor;
});
function GridContainer(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_bfBaseStyles.MaterialTheme, null, _react.default.createElement(GridContainerStyles, Object.assign({
    maxWidth: props.spansFullPage === true ? false : props.customWidth ? props.customWidth : 'lg',
    disableGutters: props.spansFullPage === true
  }, props), children));
}
var _default = GridContainer;
exports.default = _default;